// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-LangSwitcher-LangSwitcher-module__langSwitcher--jH71C {
  cursor: pointer;
}
/*# sourceMappingURL=LangSwitcher.module.css.map */`, "",{"version":3,"sources":["webpack://./LangSwitcher.module.less","webpack://./src/components/LangSwitcher/LangSwitcher.module.less"],"names":[],"mappings":"AAEA;EACE,eAAA;ACDF;AACA,kDAAkD","sourcesContent":["@import \"/src/variables.less\";\n\n.langSwitcher {\n  cursor: pointer;\n}\n",".langSwitcher {\n  cursor: pointer;\n}\n/*# sourceMappingURL=LangSwitcher.module.css.map */"],"sourceRoot":""}]);
// Exports
export var langSwitcher = `src-components-LangSwitcher-LangSwitcher-module__langSwitcher--jH71C`;
export default ___CSS_LOADER_EXPORT___;
